import { useAtomValue } from "jotai";
import { atomWithStorage, useResetAtom } from "jotai/utils";

import { createStorageKey } from "@/utils/storage";

const STORAGE_KEY = createStorageKey("most-recent-account-id");

/**
 * The most recently viewed workspace, persisted so that a load of "/" can
 * redirect straight to it.
 */
export const mostRecentAccountId = atomWithStorage<string | null>(
  STORAGE_KEY,
  null,
);

export function useMostRecentAccountId() {
  return useAtomValue(mostRecentAccountId);
}

export function useResetMostRecentAccountId() {
  return useResetAtom(mostRecentAccountId);
}

/** The stored id as the atom would read it, for callers that run before any atom is mounted. */
export function readMostRecentAccountId(): string | null {
  try {
    const parsed: unknown = JSON.parse(
      localStorage.getItem(STORAGE_KEY) ?? "null",
    );
    return typeof parsed === "string" ? parsed : null;
  } catch {
    return null;
  }
}

/** The account a load of "/" redirects to, or undefined when it goes to the workspace list instead. */
export function findMostRecentAccount<T extends { id: string }>(
  accounts: readonly T[],
  storedId: string | null,
): T | undefined {
  if (!storedId) return undefined;
  return accounts.find((account) => account.id === storedId);
}
